<div>
    <p class="title">Are you sure to clear cache for these devices?</p>
    <div class="content">{{ _monitorDeviceNames }}</div>
</div>